
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/[slug]",
      function () {
        return require("private-next-pages/activities/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/[slug]"])
      });
    }
  